import React, { memo } from 'react';
import { Plus } from 'lucide-react';
import { AppNode } from '@/types';

interface InputPortsProps {
  node: AppNode;
  isConnecting?: boolean;
  onPortMouseDown?: (e: React.MouseEvent, nodeId: string, type: 'input' | 'output') => void;
  onPortMouseUp?: (e: React.MouseEvent, nodeId: string, type: 'input' | 'output') => void;
}

const InputPortsInner: React.FC<InputPortsProps> = ({
  node,
  isConnecting = false,
  onPortMouseDown,
  onPortMouseUp,
}) => {
  if (node.type === 'MEDIA_UPLOAD') return null;

  return (
    <div
      className={`absolute -left-3 top-1/2 -translate-y-1/2 w-4 h-4 rounded-full border border-white/20 bg-[#262626] flex items-center justify-center transition-all duration-300 hover:scale-125 cursor-default z-50 shadow-md ${
        isConnecting ? 'ring-2 ring-cyan-400 animate-pulse' : ''
      }`}
      onMouseDown={(e) => onPortMouseDown?.(e, node.id, 'input')}
      onMouseUp={(e) => onPortMouseUp?.(e, node.id, 'input')}
      title="Input"
    >
      <Plus size={10} strokeWidth={3} className="text-white/50" />
    </div>
  );
};

export const InputPorts = memo(InputPortsInner, (prevProps, nextProps) => {
  return (
    prevProps.node.id === nextProps.node.id &&
    prevProps.node.type === nextProps.node.type &&
    prevProps.isConnecting === nextProps.isConnecting
  );
});